import { getWorkspaceRightPanelKey, WORKSPACE_RIGHT_PANEL } from '~/constants/localStorageKeys';
import { WORKSPACE_DEFAULT_WIDTH } from '~/constants/panelWidths';
import { CURRENT_WORKSPACE_NAV_WIDTH } from '~/constants/sideNav';

export const getInitialRightPanelWidth = (workspaceId?: string): number => {
  if (typeof window === 'undefined') {
    return CURRENT_WORKSPACE_NAV_WIDTH;
  }

  const key = workspaceId ? getWorkspaceRightPanelKey(workspaceId) : WORKSPACE_RIGHT_PANEL;
  const stored = window.localStorage.getItem(key);

  if (stored) {
    const parsed = parseInt(stored, 10);

    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }
  }

  // Default: right panel fills viewport minus sidenav minus the target workspace width
  return Math.max(0, window.innerWidth - CURRENT_WORKSPACE_NAV_WIDTH - WORKSPACE_DEFAULT_WIDTH);
};
